import { SCRAPE_DATA } from '../data/scrapeData';
import { GLOBAL_COMPANY_INFO, getResizedImageUrl } from '../lib/cms';
import ContactForm from '../components/ContactForm';

export default function ContactPage() {
  return (
    <div className="bg-[#F8FAFC] pt-28 pb-20">
      
      {/* Banner */}
      <section className="bg-[#1D352E] text-white py-16 mb-16 -mt-[10px]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-4">
            <span className="text-white text-sm font-semibold tracking-wider uppercase">
              Kontakt os
            </span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight">
              {SCRAPE_DATA.kontakt.mainHeading}
            </h1>
            <p className="text-gray-200 text-lg">
              {SCRAPE_DATA.kontakt.subHead}
            </p>
          </div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          
          {/* Left Column: Business Details & Intro */}
          <div className="lg:col-span-5 space-y-8">
            <div className="bg-white rounded-3xl border border-slate-200 shadow-sm overflow-hidden">
              
              {/* Profile Image of Carsten Janum */}
              <div className="relative bg-[#1D352E]">
                <img
                  src={getResizedImageUrl('https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240101-221222.jpg', 1000, 85)}
                  alt="Carsten Janum - Malermester"
                  className="w-full h-96 sm:h-[480px] object-cover object-top"
                />
                <div className="absolute top-6 left-6 right-6 text-white">
                  <span className="inline-block px-2.5 py-1 bg-[#65237e] text-white text-xs font-semibold uppercase tracking-wider rounded-md mb-1.5">
                    Malermester &amp; Indehaver
                  </span>
                  <h3 className="text-2xl font-bold tracking-tight text-white">
                    Carsten Janum
                  </h3>
                  <p className="text-xs text-gray-200">
                    Din personlige maler i Aalborg &amp; omegn
                  </p>
                </div>
              </div>

              <div className="p-8 sm:p-10 space-y-6">
                <h2 className="text-2xl font-bold text-[#1D352E]">
                  {SCRAPE_DATA.kontakt.subHead}
                </h2>

                <p className="text-gray-700 leading-relaxed text-base">
                  {SCRAPE_DATA.kontakt.body}
                </p>

                <div className="h-px bg-gray-100 my-4" />

                <div className="space-y-4">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-[#1D352E] text-white flex items-center justify-center text-lg shrink-0 mt-0.5">
                      <i className="fa-solid fa-phone" aria-hidden="true" />
                    </div>
                    <div>
                      <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                        Telefon
                      </div>
                      <a
                        href={`tel:${GLOBAL_COMPANY_INFO.phone_raw}`}
                        className="text-lg font-bold text-[#1D352E] hover:text-[#65237e] transition-colors nowrap-contact"
                      >
                        <span className="nowrap-contact">{GLOBAL_COMPANY_INFO.phone}</span>
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-[#1D352E] text-white flex items-center justify-center text-lg shrink-0 mt-0.5">
                      <i className="fa-solid fa-envelope" aria-hidden="true" />
                    </div>
                    <div>
                      <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                        E-mail
                      </div>
                      <a
                        href={`mailto:${GLOBAL_COMPANY_INFO.email}`}
                        className="text-lg font-bold text-[#1D352E] hover:text-[#65237e] transition-colors nowrap-contact"
                      >
                        <span className="nowrap-contact">{GLOBAL_COMPANY_INFO.email}</span>
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-[#1D352E] text-white flex items-center justify-center text-lg shrink-0 mt-0.5">
                      <i className="fa-solid fa-location-dot" aria-hidden="true" />
                    </div>
                    <div>
                      <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                        Adresse
                      </div>
                      <a
                        href="https://maps.app.goo.gl/EEHR9Do197bH6CRU9"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-base font-semibold text-[#1D352E] hover:text-[#65237e] transition-colors"
                      >
                        {GLOBAL_COMPANY_INFO.address}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-[#1D352E] text-white flex items-center justify-center text-lg shrink-0 mt-0.5">
                      <i className="fa-solid fa-id-card" aria-hidden="true" />
                    </div>
                    <div>
                      <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                        CVR-nummer
                      </div>
                      <div className="text-base font-semibold text-[#1D352E]">
                        {GLOBAL_COMPANY_INFO.cvr}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Map Link Card */}
            <div className="bg-[#1D352E] text-white rounded-3xl p-8 shadow-md space-y-4">
              <h3 className="text-xl font-bold text-white">Arbejdsområde</h3>
              <p className="text-sm text-gray-200 leading-relaxed">
                Vi har base i Aalborg og kører fast i Nørresundby, Brønderslev, Støvring samt øvrige Nord- og Midtjylland. Vi tilbyder også gerne tilbud på større projekter i resten af Danmark.
              </p>
              <a
                href="https://maps.app.goo.gl/EEHR9Do197bH6CRU9"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-white hover:text-gray-200 transition-colors pt-2"
              >
                <span>Find os på Google Maps</span>
                <i className="fa-solid fa-arrow-up-right-from-square" />
              </a>
            </div>
          </div>

          {/* Right Column: Contact Form */}
          <div className="lg:col-span-7 lg:sticky lg:top-28">
            <ContactForm />
          </div>

        </div>
      </div>
    </div>
  );
}
